import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { FaqService } from '../../services/faq.service';
import { IFaqDto } from '../../interfaces/Faq/ifaq-dto';

@Component({
  selector: 'app-audits',
  templateUrl: './audits.component.html',
  styleUrls: ['./audits.component.css']
})
export class FaqAuditsComponent implements OnInit {

  faq: IFaqDto;

  constructor(private sharedService: SharedService, private faqService: FaqService) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadFaq();
  }

  loadFaq() {
    this.faqService.getFaqByCode('audits').subscribe(result => {
      this.faq = result;
      this.sharedService.showLoadingMessage = false;
    }, error => {
      console.error(error);
      this.sharedService.showLoadingMessage = false;
    });
  }
}
